<template>
  <v-container>
    <v-dialog :model-value="dialog" @update:model-value="$emit('update:dialog', $event)" max-width="600px">
      <v-card>
        <v-card-title>Perfil de Usuario</v-card-title>
        <v-card-text>
          <v-row>
            <!-- Foto de perfil -->
            <v-col cols="12" md="4" class="text-center">
              <v-avatar size="150" class="mb-3" v-if="user">
                <v-img v-if="user.avatar" :src="user.avatar" @click="activarSubidaImagen"></v-img>
                <v-img v-else :src="this.$store.state.defaultAvatar" @click="activarSubidaImagen"></v-img>
              </v-avatar>
              <input 
                type="file" 
                ref="fileInput" 
                accept="image/*" 
                style="display:none" 
                @change="procesarImagen"
              />
              <div>
                <h3 class="editable" @click="cambiarAtributoUsuario('name')">{{ user.name || "Nombre de usuario ✏️" }}</h3>
                <p>{{ user.email }}</p>
              </div>
            </v-col>

            <!-- Información del usuario -->
            <v-col cols="12" md="8">
              <v-table dense>
                <tbody>
                  <tr>
                    <td><strong>Institución:</strong></td>
                    <td class="editable" @click="cambiarAtributoUsuario('institution')">
                      {{ user.institution || "Sin institución" }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Rol:</strong></td>
                    <td>{{ user.role || "Sin rol" }}</td>
                  </tr>
                </tbody>
              </v-table>

              <!-- Cambiar contraseña -->
              <v-text-field v-model="password.new" label="Nueva contraseña" type="password" class="mt-3"></v-text-field>
              <v-text-field v-model="password.repeat" label="Repite nueva contraseña" type="password"></v-text-field>
              <v-btn color="primary" @click="updatePassword">Actualizar contraseña</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api.js';
export default {
  name: 'UserProfile',
  props: {
    dialog: Boolean
  },
  watch: {
    user: {
      deep: true,
      handler(newUser) {
        // Almacenar versión simplificada sin avatar para evitar exceder la cuota
        const userForStorage = { ...newUser };
        delete userForStorage.avatar; // Eliminar el avatar para evitar exceder la cuota
        localStorage.setItem('user', JSON.stringify(userForStorage));
      }
    }
  },
  data() {
    return {
      password: { new: '', repeat: '' },
      user: {},
      newUser: {},
      showUserProfile: true,
    };
  },
  methods: {
    async updatePassword() {
      if (this.password.new !== this.password.repeat) {
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'Las contraseñas no coinciden',
            color: 'error',
            icon: 'mdi-alert'
          }
        );
        return;
      }
      try {
        await api.put(`/api/user/update/${this.user._id}/profile`, { password: this.password.new }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.password.new = '';
        this.password.repeat = '';
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'Contraseña actualizada correctamente',
            color: 'success',
            icon: 'mdi-check-circle'
          }
        );
      } catch (e) {
        console.log(e);
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'Error al actualizar la contraseña',
            color: 'error',
            icon: 'mdi-alert'
          }
        );
      }
    },
    async getUser() {
      try {
        const response = await api.get('/api/user/userLogin', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.user = response.data;
        
        // Actualizar la store con el usuario completo (con avatar)
        this.$store.commit('setUser', this.user);
        
        // No es necesario guardar en localStorage aquí, ya que el watcher lo hará
        // sin incluir el avatar
      } catch (e) {
        console.log(e);
      }
    },
    activarSubidaImagen() {
      this.$refs.fileInput.click();
    },
    procesarImagen(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      // Validar tamaño (5MB máximo)
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 5) {
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'La imagen no debe superar los 5MB',
            color: 'error',
            icon: 'mdi-alert'
          }
        );
        return;
      }
      
      // Convertir a base64
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        try {
          const base64Image = reader.result;
          this.user.avatar = base64Image;
          
          await api.put(`/api/user/update/${this.user._id}/profile`, { avatar: base64Image }, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
          
          this.$store.commit(
            'setSnackbar', 
            {
              text: 'Imagen de perfil actualizada correctamente',
              color: 'success',
              icon: 'mdi-check-circle'
            }
          );
          
          // Actualizar la imagen en la store
          this.$store.commit('setUser', this.user);
          
        } catch (e) {
          console.log(e);
          this.$store.commit(
            'setSnackbar', 
            {
              text: 'Error al actualizar la imagen de perfil',
              color: 'error',
              icon: 'mdi-alert'
            }
          );
        }
      };
      
      reader.onerror = (error) => {
        console.log('Error al leer el archivo:', error);
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'Error al procesar la imagen',
            color: 'error',
            icon: 'mdi-alert'
          }
        );
      };
    },
    async cambiarAtributoUsuario(attr) {
      if (attr === 'avatar') {
        this.activarSubidaImagen();
        return;
      }
      
      const newValue = prompt(`Ingresa el nuevo valor para ${attr}`);
      if (!newValue) return;
      this.user[attr] = newValue;
      try {
        await api.put(`/api/user/update/${this.user._id}/profile`, { [attr]: newValue }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
      } catch (e) {
        console.log(e);
      }
    }
  },
  async created() {
    await this.getUser();
  },
};
</script>

<style scoped>
.editable {
  cursor: pointer;
}
.editable:hover {
  text-decoration: underline;
}
.v-avatar {
  cursor: pointer;
}
</style>
